import { render, staticRenderFns } from "./AddPhraseDialog.vue?vue&type=template&id=e6c1cbdc&scoped=true"
import script from "./AddPhraseDialog.vue?vue&type=script&lang=js"
export * from "./AddPhraseDialog.vue?vue&type=script&lang=js"
import style0 from "./AddPhraseDialog.vue?vue&type=style&index=0&id=e6c1cbdc&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6c1cbdc",
  null
  
)

export default component.exports